// eslint-disable-next-line import/no-extraneous-dependencies
import { Property } from 'csstype';
import tinycolor from 'tinycolor2';

const primary = '#78001b';
const secondary = '#FF5C93';
const warning = '#FFC260';
const success = '#3CD4A0';
const info = '#9013FE';

const lightenRate = 7.5;
const darkenRate = 15;

export default {
  palette: {
    primary: {
      main: primary,
      light: tinycolor(primary)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(primary)
        .darken(darkenRate)
        .toHexString(),
    },
    secondary: {
      main: secondary,
      light: tinycolor(secondary)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(secondary)
        .darken(darkenRate)
        .toHexString(),
      contrastText: '#FFFFFF',
    },
    warning: {
      main: warning,
      light: tinycolor(warning)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(warning)
        .darken(darkenRate)
        .toHexString(),
    },
    success: {
      main: success,
      light: tinycolor(success)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(success)
        .darken(darkenRate)
        .toHexString(),
    },
    info: {
      main: info,
      light: tinycolor(info)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(info)
        .darken(darkenRate)
        .toHexString(),
    },
    text: {
      primary: '#4A4A4A',
      secondary: '#6E6E6E',
      hint: '#B9B9B9',
    },
    background: {
      default: '#F6F7FF',
      light: '#F3F5FF',
    },
  },
  customShadows: {
    widget:
      '0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
    widgetDark:
      '0px 3px 18px 0px #4558A3B3, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
    widgetWide:
      '0px 12px 33px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
  },
  overrides: {
    MuiBackdrop: {
      root: {
        backgroundColor: '#4A4A4A1A',
      },
    },
    MuiMenu: {
      paper: {
        boxShadow:
          '0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
      },
    },
    MuiSelect: {
      icon: {
        color: '#B9B9B9',
      },
    },
    MuiListItem: {
      root: {
        '&$selected': {
          backgroundColor: '#F3F5FF !important',
          '&:focus': {
            backgroundColor: '#F3F5FF',
          },
        },
      },
      button: {
        '&:hover, &:focus': {
          backgroundColor: '#F3F5FF',
        },
      },
    },
    MuiTouchRipple: {
      child: {
        backgroundColor: 'white',
      },
    },
    MuiTableRow: {
      root: {
        height: 56,
      },
    },
    MuiTable: {
      root: {
        margin: '15px',
        width: '95%',
        '& thead': {
          '& tr': {
            // height : 40,
            '& th': {
              // fontSize      : '0.85rem',
              // fontWeight    : 600,
              // padding       : '8px',
              textTransform: 'uppercase' as Property.TextTransform,
              '& svg': {
                width: 17,
                position: 'relative',
                top: 7,
              },
            },
          },
        },
        '& tbody': {
          '& tr': {
            // height : 30,
            '& td': {
              backgroundColor: 'transparent',
              // fontSize : '13px',
              // padding  : '8px 5px',
              '& a': {
                cursor: 'pointer',
                textDecoration: 'none',
                '& svg': {
                  color: primary,
                },
              },
              '& > button': {
                color: '#ccc',
                height: 16,
                marginLeft: 5,
                marginRight: 5,
                width: 16,
                padding: 0,
                '& svg': {
                  color: primary,
                  width: '100%',
                  position: 'relative',
                  top: -3,
                },
              },
              '& .MuiCheckbox-root': {
                // padding : 0
              },
            },
            '& td:first-child': {
              // paddingLeft: 10
            },
          },
          '& tr.Mui-selected': {
            backgroundColor: '#78001b2e',
          },
          '& tr:hover': {
            backgroundColor: '#78001b2e !important',
          },
        },
      },
    },
    MUIDataTableToolbarSelect: {
      root: {
        backgroundColor: '#78001b',
        marginTop: 20,
        '& h6': {
          color: '#fff',
          // fontWeight : 400
        },
        '& svg': {
          color: '#fff',
        },
      },
    },
    MuiBreadcrumbs: {
      root: {
        '& li': {
          // fontSize : 12
        },
        '& svg': {
          top: 5,
          position: 'relative',
          width: 13,
        },
        '& a:hover': {
          // textDecoration : 'none',
          color: '#4A4A4A',
        },
      },
    },
    MUIDataTableToolbar: {
      root: {
        marginTop: 20,
        // '@media (min-width: 600px)' : {
        //   '& div:nth-child(2n)' : {
        //     textAlign : 'left'
        //   }
        // }
      },
    },
    MuiInputLabel: {
      root: {
        textTransform: 'uppercase' as Property.TextTransform,
      },
    },
  },
};
